import { apiClient } from './api';
import type { Product, ProductFilters, CreateProductRequest, UpdateProductData } from '../types/product';

interface ProductListResponse {
  products: Product[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

class ProductService {
  /**
   * Get paginated list of products with optional filtering
   */
  async getProducts(
    page: number = 1, 
    filters: ProductFilters = {}, 
    limit: number = 25,
    viewAllOrgs: boolean = false
  ): Promise<ProductListResponse> {
    try {
      const response = await apiClient.getProducts(page, filters, limit, viewAllOrgs);
      return response;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  /**
   * Get single product by ID
   */
  async getProductById(id: string): Promise<{ product: Product }> {
    try {
      const response = await apiClient.getProductById(id);
      return response;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  }

  /**
   * Create new product
   */
  async createProduct(data: CreateProductRequest): Promise<{ product: Product }> {
    try {
      const response = await apiClient.createProduct(data);
      return response;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  }

  /**
   * Update existing product
   */
  async updateProduct(id: string, data: UpdateProductData): Promise<{ product: Product }> {
    try {
      const response = await apiClient.updateProduct(id, data);
      return response;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  }

  /**
   * Delete product
   */
  async deleteProduct(id: string): Promise<{ message: string }> {
    try {
      const response = await apiClient.deleteProduct(id);
      return response;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  }
}

export const productService = new ProductService(); 